import * as React from 'react';

import { To, NavigateOptions } from 'react-router-dom';

type TGlobalNavigatePrompt = {
  isPromptOpen: boolean;
  setIsPromptOpen: (isPromptOpen: boolean) => void;

  navigateTo: To | undefined;
  setNavigateTo: (navigateTo: To | undefined) => void;

  navigateOptions: NavigateOptions | undefined;
  setNavigateOptions: (navigateOptions: NavigateOptions | undefined) => void;
};

interface IGlobalNavigatePromptProvider {
  children: React.ReactNode;
}

const GlobalNavigatePromptContext = React.createContext<TGlobalNavigatePrompt>(undefined!);

export function GlobalNavigatePromptProvider({ children }: IGlobalNavigatePromptProvider) {
  const [isPromptOpen, setIsPromptOpen] = React.useState<boolean>(false);
  const [navigateTo, setNavigateTo] = React.useState<To | undefined>(undefined!);
  const [navigateOptions, setNavigateOptions] = React.useState<NavigateOptions | undefined>(undefined!);

  const globalNavigatePrompt = React.useMemo<TGlobalNavigatePrompt>(() => ({
    isPromptOpen,
    setIsPromptOpen,

    navigateTo,
    setNavigateTo,

    navigateOptions,
    setNavigateOptions,
  }), [isPromptOpen, navigateTo, navigateOptions]);

  return (
    <GlobalNavigatePromptContext.Provider value={globalNavigatePrompt}>
      {children}
    </GlobalNavigatePromptContext.Provider>
  );
}

export const useGlobalNavigatePrompt = () => React.useContext(GlobalNavigatePromptContext);
